export const telType = new RegExp(/^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/)
/**
 * @description - 密码校验；密码必须以字母开头，必须包含数字、特殊字符，长度不小于8位
 * @param {string} pwd 
 * @returns 
 */
export const validatePwd = (pwd) => {
    return pwd.length >= 8 && (/^[a-zA-z](.*)/.test(pwd)&&/(.*)[-`=\\\[\];',./~!@#$%^&*()_+|{} :"<>?](.*)/.test(pwd)&& /(.*)[\d](.*)/.test(pwd));
}